<template>
    <div>
        <p class="widget-item-title">
            <span v-if="title">{{ title }}</span>
            <span v-if="itemLink" class="to-link">
                (<a :href="itemLink" class="page-link" target="_blank" @click.stop=""
                    >{{ toLinkTitle || t(`create-course.go_to`) }} -></a
                >)
            </span>
        </p>
        <span class="text-base mt-3 text-gray" v-if="type && item && type === 'offers' && item.is_draft">
            {{ t("automation.draft") }}
        </span>
    </div>
</template>

<script>
export default {
    name: "MarketingDataWidgetItemTitle",
    props: {
        type: {
            type: String,
            default: null
        },
        title: {
            type: [String, Object],
            required: true
        },
        id: {
            type: [Number, String],
            required: true
        },
        link: {
            type: String,
            default: null
        },
        item: {
            type: Object,
            default: null
        },
        toLinkTitle: {
            type: String,
            default: null
        }
    },
    computed: {
        itemLink() {
            if (!this.link) return null
            return this.link.includes("/id") ? this.link.replace("id", this.id) : this.link
        }
    }
}
</script>

<style lang="sass" scoped>
.widget-item-title
    font-family: Inter, sans-serif
</style>
